module.exports = [{
      plugin: require('F:/Zlecenia/sekr-gb/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
